import { mutationTypes } from './types'
import initialState from './initial-state'

export default {
  [mutationTypes.RESET_STATE]: (state, dirty) => {
    const initState = initialState()
    Object.keys(initState).forEach(key => {
      state[key] = initState[key]
    })
  },
  [mutationTypes.GET_SEARCH_RESULTS_PENDING]: (state, params) => {
    state.errors = []
    state.isLoading = true
    state.params = params
    state.showSearchResults = true
  },
  [mutationTypes.GET_SEARCH_RESULTS_FAILURE]: (state, errors) => {
    state.errors = errors
    state.searchResults = []
    state.isLoading = false
    state.success = false
    state.params = {}
  },
  [mutationTypes.GET_SEARCH_RESULTS_SUCCESS]: (state, searchResults) => {
    state.searchResults = searchResults
    state.success = true
    state.errors = []
    state.isLoading = false
  },
  [mutationTypes.DISTRIBUTE_CATEGORY_PENDING]: (state, payload) => {
    const { category } = payload
    state[category].errors = []
    state[category].isLoading = true
  },
  [mutationTypes.DISTRIBUTE_CATEGORY_FAILURE]: (state, payload) => {
    const { category, errors } = payload
    state[category].errors = errors
    state[category].results = []
    state[category].isLoading = false
  },
  [mutationTypes.DISTRIBUTE_CATEGORY_SUCCESS]: (state, payload) => {
    const { category, results } = payload
    state[category].results = results
    state[category].errors = []
    state[category].isLoading = false
  },
  [mutationTypes.GO_BACK_TO_RECENT_WORKSPACES]: (state) => {
    state.showSearchResults = false
  }
}
